// The bootcamp funnel, in order, and how each step scores. The server scores from
// server/scoring.js; keep the two in step.
export const STAGES = [
  { key: 'contacted', label: 'Contacted', short: 'Contacted', points: 0 },
  { key: 'qc', label: 'Quality conversation', short: 'Quality conversation', points: 1 },
  { key: 'appset', label: 'Appointment set', short: 'Appt set', points: 2 },
  { key: 'appshown', label: 'Appointment shown', short: 'Shown', points: 3 },
  { key: 'sold', label: 'Sold', short: 'Sold', points: 5 },
];

export const REFERRAL_POINTS = 2;
export const MAX_REFERRALS = 10;

export const tally = (customers = []) => {
  const totals = { contacted: 0, qc: 0, appset: 0, appshown: 0, sold: 0, referrals: 0, customers: customers.length };
  for (const c of customers) {
    for (const s of STAGES) if (c[s.key]) totals[s.key] += 1;
    totals.referrals += Number(c.referrals) || 0;
  }
  totals.points = STAGES.reduce((sum, s) => sum + totals[s.key] * s.points, 0) + totals.referrals * REFERRAL_POINTS;
  return totals;
};

export const fullName = (u) => [u.firstName, u.lastName].filter(Boolean).join(' ') || u.username || '';
